import { useEffect, useState } from "react";
import imageUrlBuilder from "@sanity/image-url";
import { getFile } from "@sanity/asset-utils";

import sanityClient from "../client.js";

const VideoSlide = (props) => {
  const { slide, index, currentIndex, isMobile } = props;

  const [imageSrc, setImageSrc] = useState(null);
  const [vidSrc, setVidSrc] = useState(null);

  const builder = imageUrlBuilder(sanityClient);
  function urlFor(source) {
    return builder.image(source);
  }

  useEffect(()=>{
    if(isMobile && slide.coverImageMobile){
        setImageSrc(`${urlFor(slide.coverImageMobile)}`)
    } else {
        setImageSrc(`${urlFor(slide.coverImage)}`);
    }

    if(isMobile && slide.coverVideoMobile){
        setVidSrc(getFile(slide.coverVideoMobile, sanityClient.config()).asset.url)
    }  else if (isMobile && !slide.coverVideoMobile && slide.coverVideo) {
        setVidSrc(getFile(slide.coverVideo, sanityClient.config()).asset.url);
    } else if (!isMobile && slide.coverVideo) {
        setVidSrc(getFile(slide.coverVideo, sanityClient.config()).asset.url);
    }
  },[isMobile]);

  const [defaultBackground, setDefaultBackground] = useState("#FFF");
  const [isCurrentSlide, setIsCurrentSlide] = useState(false);

  useEffect(() => {
    if (slide.color === "white") {
      setDefaultBackground("#000");
    } else if (slide.color === "black") {
      setDefaultBackground("#FFF");
    } else {
      setDefaultBackground("#FFF");
    }
  }, []);

  useEffect(() => {
    if (index === currentIndex) {
      setIsCurrentSlide(true);
    } else {
      setIsCurrentSlide(false);
    }
  }, [index, currentIndex]);

  return (
    <div
      className={`carousel__video-slide ${isCurrentSlide ? "active" : ""} ${slide.layout}`}
      style={{
        backgroundColor:
          slide.background !== "" ? `${slide.background}` : defaultBackground,
      }}
    >
        <video
          src={vidSrc}
          autoPlay
          muted
          playsInline
          loop
          className={`carousel__video ${slide.layout}`}
          poster={imageSrc}
        />
    </div>
  );
};

export default VideoSlide;
